import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { CANDLE_FAMILIES } from './salesData';
export function VarietySection() {
  return <section id="variedad" className="bg-sand py-11 sm:py-14" data-id="element-187" data-mp="33dpev2xyovyl">
      <div className="mx-auto max-w-md px-5 sm:max-w-3xl" data-id="element-188" data-mp="33d5xpog4yblm">
        <div className="text-center" data-id="element-189" data-mp="38c8xouh9drmq">
          <h2 className="mx-auto max-w-[22ch] font-display text-[1.4rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:text-[2rem]" data-id="element-190" data-mp="38b7fm61ts4vi">
            Qué podés fabricar
          </h2>
          <p className="mx-auto mt-2.5 max-w-[38ch] font-sans text-[0.86rem] leading-relaxed text-taupe" data-id="element-191" data-mp="2zdn84fdddccg">
            10 familias de velas, de tu primera vela a líneas que parecen de boutique.
          </p>
        </div>

        <motion.ul initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 grid gap-1.5 sm:grid-cols-2" data-id="element-192" data-mp="2pk6i7mgcshe2">
          {CANDLE_FAMILIES.map(family => <li key={family} className="flex items-center gap-2.5 rounded-xl bg-white px-3 py-2.5 font-display text-[0.82rem] font-semibold leading-tight text-charcoal" data-id="element-193" data-mp="x2vpj9bpxm9q">
              <FlameIcon className="h-3.5 w-3.5 shrink-0 text-gold" aria-hidden strokeWidth={2.5} data-id="element-194" data-mp="171l6mzvsj2ox" />
              {family}
            </li>)}
        </motion.ul>
      </div>
    </section>;
}